import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import LanguageContext from '../../modules/contexts/LanguageContext';

const LanguageSwitcher = () => {
  const { t, i18n } = useTranslation('common');
  const { currentLanguage, changeLanguage } = useContext(LanguageContext);

  // Make sure UI reflects the actual language
  useEffect(() => {
    if (i18n.language !== currentLanguage) {
      i18n.changeLanguage(currentLanguage);
    }
  }, [currentLanguage, i18n]);

  const toggleLanguage = () => {
    console.log("Switching language from", currentLanguage);
    const newLanguage = currentLanguage === 'en' ? 'sw' : 'en';
    changeLanguage(newLanguage);
    console.log("Switched to", newLanguage);
  };

  return (
    <div className="flex items-center">
      <button
        className="flex items-center space-x-1 text-sm font-medium py-1 px-2 rounded hover:bg-gray-100 transition-colors"
        onClick={toggleLanguage}
        aria-label={t('switchLanguage')}
      >
        <span className="font-medium">{currentLanguage === 'en' ? 'EN' : 'SW'}</span>
        {currentLanguage === 'en' ? (
          <img 
            src="/flags/gb.svg" 
            alt="UK Flag" 
            className="w-4 h-4 object-contain"
          />
        ) : (
          <img 
            src="/flags/ke.svg" 
            alt="Kenya Flag" 
            className="w-4 h-4 object-contain"
          />
        )}
      </button>
    </div>
  );
};

export default LanguageSwitcher; 